<iframe [src]="this.getUI() | safe" style="width: 100%; height: 700px;"></iframe>
